module.exports = __webpack_public_path__ + "static/media/autumn-che-big.d250207c.png";